import angular from 'angular';
import '../../../app/components/filter/company-autocomplete-filter.js';
import gridHeight from '../../../app/core/shared-service/grid-utils';
import EnvelopeFilters from '../envelope/envelope-filters.data';

class ResumptionCtrl {
  /*@ngInject*/
  constructor(
    $uibModal,
    $sessionStorage,
    $translate,
    AuthSvc,
    dateFilter,
    toastr,
    EnvelopeService,
    CompanyService,
    uiGridConstants,
    ContainerService,
    DateService,
    UtilSvc
  ) {
    this.$uibModal = $uibModal;
    this.$sessionStorage = $sessionStorage;
    this.$translate = $translate;
    this.AuthSvc = AuthSvc;
    this.dateFilter = dateFilter;
    this.toastr = toastr;
    this.EnvelopeService = EnvelopeService;
    this.CompanyService = CompanyService;
    this.uiGridConstants = uiGridConstants;
    this.ContainerService = ContainerService;
    this.DateService = DateService;
    this.UtilSvc = UtilSvc;
  }

  $onInit() {
    let vm = this;

    // Accès raccourcis aux autorisations depuis le scope principal
    vm.isAuthorized = vm.AuthSvc.isAuthorized;
    vm.getTableHeight = getTableHeight;

    vm.criteria = {
      envelopeId: [],
      envelopeStatus: 'TERMINATED',
      principalId: [],
      containerId: undefined,
      sender: [],
      senderName: [],
      companyName: [],
      containerType: [],
      containerMode: [],
      refClient: [],
      createdDateFrom: [],
      createdDateTo: [],
      createdTimeFrom: [],
      createdTimeTo: []
    };

    vm.criteriaResumption = {
      envelopesIds: [],
      generateBatchPlatform: false,
      ladProviderIdPlatform: undefined,
      generateBatchQuali: false,
      ladProviderIdQuali: undefined,
      excludeBatchSendedOrLinkToMessage: false
    };

    var containers = vm.ContainerService.findAll();

    // Liste les containers disponibles en fonction de la société sélectionnée
    vm.listContainers = function() {
      var filteredContainers = [];
      angular.forEach(containers, function(value /*, key*/) {
        var keep = false;
        if (vm.selected.company) {
          keep = value.companyId === vm.selected.company.companyId;
        } else if (vm.selected.principalId) {
          keep = value.principalId === vm.selected.principalId;
        } else {
          keep = true;
        }

        if (keep) {
          filteredContainers.push(value);
        }
      });
      return filteredContainers;
    };

    vm.selected = {};

    initEnvelopesSearchFilter();
    initEnvelopesSearchValues();

    vm.clearSearchEnvelopes = function() {
      initEnvelopesSearchFilter();
      initEnvelopesSearchValues();
      vm.resumptionGridOptions.data = searchByCriterias();
    };

    vm.searchEnvelopes = function() {
      cleanEnvelopeFormParam();
      vm.criteria.principalId = vm.selected.principalId;
      vm.criteria.companyName = vm.selected.company && vm.selected.company.companyName;
      vm.criteria.senderName = vm.selected.seller && vm.selected.seller.legalEntity && vm.selected.seller.legalEntity.name;
      vm.$sessionStorage.resumptionHistorySearchCriteria = vm.criteria;
      vm.$sessionStorage.resumptionHistorySearchCriteriaBis = vm.selected;
      vm.resumptionGridOptions.data = searchByCriterias();
      vm.resumptionPromise = vm.resumptionGridOptions.data.$promise;
    };

    var defaultCellTemplate =
      '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: vm.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
    var statusCellTemplate =
      '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: vm.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD | translate}} {{row.entity.row.entity.envelopeStatus}}<span ng-if="row.entity.envelopeStatus === \'ERROR\'">{{"status.error_" + row.entity.envelopeErrorCode | translate}}</span></div></a>';
    var containerTypeCellTemplate =
      '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: vm.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{row.entity.containerMode != null ?  (("container_mode." + row.entity.containerMode | translate) + "-") : ""}}{{COL_FIELD | translate}}</div></a>';

    vm.resumptionGridOptions = {
      columnDefs: [
        {
          name: 'envelopeId',
          displayName: 'dashboard.column.envelope.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number'
        },
        {
          name: 'created',
          displayName: 'dashboard.column.envelope.created',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: vm.uiGridConstants.DESC, priority: 0 },
          cellFilter: "date:'shortDate'"
        },
        {
          name: 'envelopeStatus',
          displayName: 'dashboard.column.envelope.status',
          cellTemplate: statusCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'updated',
          displayName: 'dashboard.column.folder.last.modified',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: "date:'shortDate'"
        },
        {
          name: 'containerId',
          displayName: 'dashboard.column.envelope.container.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'containerType',
          displayName: 'principal.container.column.container.type',
          cellTemplate: containerTypeCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: 'translate'
        },
        {
          name: 'principalName',
          displayName: 'dashboard.column.envelope.principal',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number'
        },
        {
          name: 'companyName',
          displayName: 'dashboard.column.envelope.company.name',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'sender',
          displayName: 'dashboard.column.envelope.sender',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'refClient',
          displayName: 'dashboard.column.envelope.reference',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        }
      ],
      enableGridMenu: false,
      enableRowSelection: true,
      enableSelectAll: true,
      selectionRowHeaderWidth: 30,
      exporterMenuCsv: false,
      exporterMenuPdf: false,
      enableColumnMenus: false,
      exporterCsvColumnSeparator: ';',
      exporterOlderExcelCompatibility: true,
      exporterHeaderFilter: vm.$translate.instant,
      exporterFieldCallback: function(grid, row, col, value) {
        if (col.name === 'created' || col.name === 'updated') {
          value = vm.dateFilter(value, 'shortDate');
        } else if (col.name === 'containerType') {
          if (row.entity.containerType != null) {
            value =
              vm.$translate.instant('container_mode.' + row.entity.containerMode) + '-' + vm.$translate.instant(value);
          }
        } else if (col.name === 'envelopeStatus') {
          var origValue = value;
          value = vm.$translate.instant(value);
          if (origValue === 'ERROR') {
            value =
              vm.$translate.instant(value) +
              ' ' +
              vm.$translate.instant('status.error_' + row.entity.envelopeErrorCode);
          }
        }
        return value;
      },
      gridMenuTitleFilter: vm.$translate,
      onRegisterApi: function(gridApi) {
        vm.gridEnvelopesApi = gridApi;
      }
    };

    (function() {
      // init
      var resumptionHistorySearchCriteria = vm.$sessionStorage.resumptionHistorySearchCriteria;
      var resumptionHistorySearchCriteriaBis = vm.$sessionStorage.resumptionHistorySearchCriteriaBis;
      if (resumptionHistorySearchCriteria) {
        vm.criteria = resumptionHistorySearchCriteria;
      }
      if (resumptionHistorySearchCriteriaBis) {
        vm.selected = resumptionHistorySearchCriteriaBis;
      }
    })();

    vm.resumptionEnvelope = function() {
      var envelopeIds = [];
      var selectedRows = vm.gridEnvelopesApi.selection.getSelectedRows();
      for (var i = 0; i < selectedRows.length; i++) {
        envelopeIds.push(selectedRows[i].envelopeId);
      }
      vm.EnvelopeService.containsSpecificTreatment(envelopeIds, function(data) {
        if (data.length > 0) {
          openModalEnvelopeSpecific(envelopeIds, data, selectedRows.length);
        } else {
          openModalChooseLad(envelopeIds, selectedRows.length, {});
        }
      });
    };

    function searchByCriterias() {
      var criterias = new EnvelopeFilters();
      var createdDateFrom = vm.UtilSvc.mixteDateTime(vm.criteria.createdDateFrom, vm.criteria.createdTimeFrom);
      criterias.setCreatedDateFrom(createdDateFrom);
      var createdDateTo = vm.UtilSvc.mixteDateTime(vm.criteria.createdDateTo, vm.criteria.createdTimeTo);
      criterias.setCreatedDateTo(createdDateTo);
      criterias.setCompanyName(vm.criteria.companyName);
      criterias.setPrincipalId(vm.criteria.principalId);
      criterias.setContainerId(vm.criteria.containerId);
      criterias.setContainerType(vm.criteria.containerType);
      criterias.setContainerMode(vm.criteria.containerMode);
      criterias.setRefClient(vm.criteria.refClient);
      criterias.setSender(vm.criteria.sender);
      criterias.setSenderName(vm.criteria.senderName);

      return vm.EnvelopeService.searchByCriterias(vm.criteria);
    }

    function openModalEnvelopeSpecific(envelopeIds, data, nbSelected) {
      var modalInstance = vm.$uibModal.open({
        animation: true,
        templateUrl: require('./resumption-modal-lad-specific.html'),
        controller: 'LadSpecificModalCtrl',
        resolve: {
          envelopes: function() {
            return data;
          }
        }
      });
      modalInstance.result.then(function() {
        openModalChooseLad(envelopeIds, nbSelected, data);
      });
    }

    function openModalChooseLad(envelopeIds, nbSelected, data) {
      var modalInstance = vm.$uibModal.open({
        animation: true,
        templateUrl: require('./resumption-modal-choose.html'),
        controller: 'RebroadcastModalChooseCtrl',
        resolve: {
          nbSelected: function() {
            return nbSelected;
          },
          nbEnvelopeSpecific: function() {
            return data.length;
          }
        }
      });
      modalInstance.result.then(function(criteriaChoose) {
        vm.criteriaResumption.generateBatchPlatform = criteriaChoose.platform;
        vm.criteriaResumption.ladProviderIdPlatform = criteriaChoose.ladProviderIdPlatform;
        vm.criteriaResumption.generateBatchQuali = criteriaChoose.quali;
        vm.criteriaResumption.ladProviderIdQuali = criteriaChoose.ladProviderIdQuali;
        vm.criteriaResumption.envelopesIds = envelopeIds;
        vm.criteriaResumption.motif = criteriaChoose.motif;
        vm.criteriaResumption.excludeBatchSendedOrLinkToMessage = false;

        vm.EnvelopeService.containsBatchBeingOrAlreadyTreated(envelopeIds, function(result) {
          var batchAlreadyTreated = [];
          var batchBeingTreated = [];
          for (var i = 0; i < result.length; i++) {
            if (result[i].bacthAlreadyTreated) {
              batchAlreadyTreated.push(result[i]);
            } else if (result[i].bacthBeingTreated) {
              batchBeingTreated.push(result[i]);
            }
          }
          if (batchAlreadyTreated.length > 0 || batchBeingTreated.length > 0) {
            openModalAlert(batchAlreadyTreated, batchBeingTreated);
          } else {
            vm.EnvelopeService.resumption(vm.criteriaResumption);
          }
        });
      });
    }

    function openModalAlert(batchAlreadyTreated, batchBeingTreated) {
      var modalInstance = vm.$uibModal.open({
        animation: true,
        templateUrl: require('./resumption-modal-alert.html'),
        controller: 'AlertModalCtrl',
        resolve: {
          batchAlreadyTreated: function() {
            return batchAlreadyTreated;
          },
          batchBeingTreated: function() {
            return batchBeingTreated;
          }
        }
      });
      modalInstance.result.then(function(action) {
        if (action === 'exclude') {
          vm.criteriaResumption.excludeBatchSendedOrLinkToMessage = true;
        } else {
          vm.criteriaResumption.excludeBatchSendedOrLinkToMessage = false;
        }
        vm.EnvelopeService.resumption(vm.criteriaResumption);
      });
    }

    function initEnvelopesSearchValues() {
      vm.criteria.createdDateFrom = new Date();
      vm.criteria.createdDateFrom.setHours(0, 0, 0, 0);
      vm.criteria.createdDateTo = new Date();
      vm.criteria.createdDateTo.setHours(0, 0, 0, 0);
      vm.criteria.createdTimeFrom = new Date();
      vm.criteria.createdTimeFrom.setHours(0, 0, 0, 0);
      vm.criteria.createdTimeTo = new Date();
      vm.criteria.createdTimeTo.setHours(23, 59, 0, 0);
      vm.criteria.updatedTimeFrom = new Date();
      vm.criteria.updatedTimeFrom.setHours(0, 0, 0, 0);
      vm.criteria.updatedTimeTo = new Date();
      vm.criteria.updatedTimeTo.setHours(23, 59, 0, 0);
    }

    function cleanEnvelopeFormParam() {
      if (vm.criteria.containerType === '') {
        vm.criteria.containerType = undefined;
      }
      if (vm.criteria.containerMode === '') {
        vm.criteria.containerMode = undefined;
      }
    }

    function initEnvelopesSearchFilter() {
      vm.criteria.envelopeId = undefined;
      vm.criteria.principalId = undefined;
      vm.criteria.containerId = undefined;
      vm.criteria.sender = undefined;
      vm.criteria.companyName = undefined;
      vm.criteria.containerType = undefined;
      vm.criteria.containerMode = undefined;
      vm.criteria.refClient = undefined;
      vm.criteria.createdDateFrom = undefined;
      vm.criteria.createdDateTo = undefined;
      vm.criteria.createdTimeFrom = undefined;
      vm.criteria.createdTimeTo = undefined;
      vm.criteria.principalAvailableTreament = undefined;
      vm.selected.principalId = null;
      vm.selected.company = null;
    }

    // Indique si l'export CSV de la grille peut être réalisé
    vm.canExportGrid = function() {
      if (!(vm.gridEnvelopesApi === undefined || vm.gridEnvelopesApi.selection === undefined)) {
        return vm.gridEnvelopesApi.selection.getSelectedRows().length > 0;
      }
      return false;
    };

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    vm.exportGridCsv = function() {
      // Nom du fichier CSV : epdf_DateHeure_dataPlis.csv
      var now = new Date();
      var filename = 'epdf_' + vm.DateService.formatAsYMD_HM(now) + '_dataPlis.csv';
      vm.resumptionGridOptions.exporterCsvFilename = filename;

      var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
      vm.gridEnvelopesApi.exporter.csvExport('selected', 'all', myElement);
    };

    function getTableHeight() {
      return gridHeight(vm.gridEnvelopesApi);
    }
  }
}

angular.module('dashboard').component('resumption', {
  templateUrl: require('./resumption.html'),
  controller: ResumptionCtrl
});
